module.exports = __webpack_public_path__ + "2d8c926f088b8d2d6af16affd198dae1.svg";